import { AppStateType } from "./state";

export type SetTokenAction = {
  type: "SET_TOKEN";
  value: string;
};

export type AppActionType = SetTokenAction;

export const appReducer = (
  state: AppStateType,
  action: AppActionType
): AppStateType => {
  switch (action.type) {
    case "SET_TOKEN":
      if (action.value === state.token) return state;
      return { ...state, token: action.value };
    default:
      throw new Error(`Unhandled type: ${action.type}`);
  }
};
